import { render, staticRenderFns } from "./MasterDepartmentNew.vue?vue&type=template&id=6da4d818&scoped=true&lang=pug&"
import script from "./scripts/MasterDepartmentNew.js?vue&type=script&lang=js&"
export * from "./scripts/MasterDepartmentNew.js?vue&type=script&lang=js&"
import style0 from "./MasterDepartmentNew.vue?vue&type=style&index=0&id=6da4d818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da4d818",
  null
  
)

export default component.exports